(function () {
  'use strict';

  if (window.__rsiBundleInit) return;
  window.__rsiBundleInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rsi-bundle-add]');
    if (!button) return;

    var variantsAttr = button.getAttribute('data-bundle-variants') || '';
    var variantIds = variantsAttr.split(',').map(function (v) { return v.trim(); }).filter(Boolean);

    if (variantIds.length === 0) return;

    var items = variantIds.map(function (id) {
      return { id: parseInt(id, 10), quantity: 1 };
    });

    var card = button.closest('.rsi-bundle-card');
    var errorEl = card ? card.querySelector('.rsi-bundle-card__error') : null;
    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding…';
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.message || 'Could not add all items to cart.');
        });
      }
      return response.json();
    })
    .then(function () {
      button.textContent = 'Added!';

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('rsi:cart:updated'));
      document.dispatchEvent(new CustomEvent('theme:cart:open'));

      if (window.theme && window.theme.Cart && typeof window.theme.Cart.open === 'function') {
        try { window.theme.Cart.open(); } catch (e) {}
      }

      setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 2200);
    })
    .catch(function (error) {
      button.textContent = originalText;
      button.disabled = false;
      if (errorEl) {
        errorEl.textContent = error.message || 'Something went wrong. Please try again.';
        errorEl.classList.add('is-visible');
        setTimeout(function () {
          errorEl.classList.remove('is-visible');
        }, 4000);
      }
    });
  });
})();
